import { ChartConfiguration, ChartOnclick } from "@cems-eco/core/src/models";
import monitorBloc from "../../services/bloc";
import { Dataset, ReadingComponent } from "./interfaces";
import { Vue } from "vue-class-component";
import { ReadingData } from "../../services";
import router from "@/router";
import formatter from "@cems-eco/core/src/services/formatter/formatter";
import { format } from "date-fns";
import { snakeToCapital } from "@/utils";

export abstract class BaseCemsReadingComponent
  extends Vue
  implements ReadingComponent
{
  monitorBloc = monitorBloc;
  config: ChartConfiguration = new ChartConfiguration();
  datasets: Dataset[] = [];
  labels: string[] = [];
  oneMinConfig: ChartConfiguration = new ChartConfiguration();
  oneMinDatasets: Dataset[] = [];
  oneMinLabels: any[] = [];
  active = false;
  xValueMax = 10;
  isShowOneMin = false;
  equipment: any;
  site: any;
  type: String;
  search: any = {
    startDatetime: null,
    endDatetime: null,
  };
  searchToggle = false;
  abstract fetch(params);

  snakeToCapital = snakeToCapital;

  onSearchToggle() {
    this.searchToggle = !this.searchToggle;
  }

  public get option(): ChartConfiguration {
    return this.config;
  }

  public get oneMinOption(): ChartConfiguration {
    return this.oneMinConfig;
  }

  min30Onclick(res: ChartOnclick) {
    throw new Error("Method not implemented.");
  }

  backTo30min() {
    throw new Error("Method not implemented.");
  }

  openPage() {
    if (this.type == "advance") return;
    router.push("/monitor/" + this.equipment.id);
  }

  listenReadings1s(data: ReadingData) {
    if (!data) return;
    this.equipment.sensors = this.equipment.sensors.map((sensor) => {
      if (sensor.id == data.id) {
        const isSame = data.created_at == sensor.alarm_created_at;
        return {
          ...sensor,
          last_reading: Date.now(),
          value: Number(data.value).toFixed(2),
          alarm: isSame ? sensor.alarm : false,
          message: isSame ? sensor.message : "",
          alarm_type: isSame ? sensor.alarm_type : "",
          alarm_created_at: isSame ? sensor.created_at : "",
        };
      }
      return sensor;
    });
  }

  listenReadings30m(data: any) {
    try {
      if (!data) return;
      const label = formatter.shortTime(data.created_at);
      const value = Number(Number(data.value).toFixed(2));
      let shift = false;

      if (!this.labels.includes(label)) {
        this.labels.push(label);
        if (this.labels.length >= this.xValueMax) {
          this.labels.shift();
          shift = true;
        }
      }

      this.labels = this.labels.map((l) =>
        formatter.shortTime(l).includes("Invalid") ? l : formatter.shortTime(l)
      );

      this.datasets = this.datasets.map((dataset: any) => {
        if (shift) dataset.data.shift();

        if (dataset.id == data.id) {
          dataset.data.push(value);
          dataset.labels.push(data.created_at);
        }

        return dataset;
      });

      return this.updateConfig();
    } catch (e) {
      console.log(e);
    }
  }

  updateConfig() {
    this.config.data = {
      datasets: JSON.parse(JSON.stringify(this.datasets)),
      labels: JSON.parse(JSON.stringify(this.labels)),
    };
  }

  status(last_reading: number, diff = 60) {
    // More than 10 seconds means inactive
    const diffMs = Math.abs(last_reading - Date.now()); // difference in milliseconds
    return !(diffMs > diff * 1000); // 10 seconds in ms
  }

  searching() {
    const start = format(
      new Date(this.search.startDatetime),
      "yyyy-MM-dd HH:mm:ss"
    );
    const end = format(
      new Date(this.search.endDatetime),
      "yyyy-MM-dd HH:mm:ss"
    );
    const range_date = `${start},${end}`;
    this.fetch({
      range_date,
    });
  }

  reset() {
    this.search = {
      startDatetime: null,
      endDatetime: null,
    };

    this.fetch({});
  }
}
